import { AttachmentImageUploadModal } from 'components/AttachmentImageUploader';
import Breadcrumbs from 'components/Common/Breadcrumb';
import Loader from 'components/Loader';
import MiniCards from 'components/MiniCard/mini-card';
import useRequest from 'hooks/useRequest';
import { isEmpty } from 'lodash';
import map from 'lodash/map';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from 'reactstrap';
import { api } from 'utils/axios';
import { API_BASE_URL, consultationStatusEnum, GET_GENDER, MODULE_TYPE } from 'utils/constants';
import {
  getCurrentUserData,
  printBirthDifference,
  printDate,
  printDateTime,
  printDateTimeTwoLines,
  showImage,
  titleCaseIfExists,
} from 'utils/helper';
import AssignDoctorModal from './AssignDoctorModal';
import UpdateStatusModal from './components/updateStatusModal';

const ConsultationDetails = (props) => {
  const { id: consultationId } = useParams();

  const { stgURL } = getCurrentUserData();
  const [consultation, setConsultation] = useState({});
  const [openUpdateStatusModal, setOpenUpdateStatusModal] = useState(false);

  const toggleUpdateStatusModal = () => {
    setOpenUpdateStatusModal(!openUpdateStatusModal);
  };

  const [getConsultationDetails, { loading: getConsultationDetailsLoading }] = useRequest({
    url: `/consultation/admin/${consultationId}`,
    method: 'GET',
    onSuccess: (data) => {
      setConsultation(data);
    },
    onError: (err) => {
      console.warn(err);
    },
  });

  const [updateEnquiryRequest, { loading: updateEnquiryLoading }] = useRequest({
    method: 'PUT',
    onSuccess: () => {
      toast.success('Enquiry has been updated.');
      getConsultationDetails();
    },
    onError: (err) => {
      toast.error(err?.message?.message || err?.message);
    },
  });

  const [updateConsultationStatus, { loading: updateConsultationStatusLoading }] = useRequest({
    onSuccess: () => {
      toast.success('Enquiry Status has been updated.');
      getConsultationDetails();
    },
    onError: (err) => {
      toast.error(err?.message?.message || err?.message);
    },
  });

  const [createAdhocPaymentLinkRequest, { loading: createAdhocPaymentLinkLoading }] = useRequest({
    method: 'POST',
    onError: (err) => {
      toast.error(err?.message?.message || err?.message);
    },
  });
  const [createAdhocPaymentRequest, { loading: createAdhocPaymentLoading }] = useRequest({
    method: 'POST',
    url: '/subscription/admin/adhoc-payment',
    onError: (err) => {
      toast.error(err?.message?.message || err?.message);
    },
  });

  // Assing Doctors
  const [assignModalShow, setAssignModalShow] = useState(false);
  const [myDoctors, setMyDoctors] = useState([]);

  const [myDoctorsList, { loading: myDoctorsLoading }] = useRequest({
    method: 'POST',
    url: '/doctor/my-doctors',
    onSuccess: (data) => {
      setMyDoctors(data?.results);
    },
    onError: (err) => {
      toast.error(err?.message?.message || err?.message);
    },
  });

  const toggleModal = () => {
    setAssignModalShow(!assignModalShow);
  };

  const handleShowDoctorAssignModal = () => {
    toggleModal();
  };

  // Update Prescription
  const [isShowPrescriptionModal, setIsShowPrescriptionModal] = useState(false);
  const [prescriptionImageModal, setPrescriptionImageModal] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [prescriptionObj, setPrescriptionObj] = useState(null);

  const togglePrescriptionModal = () => {
    setIsShowPrescriptionModal(!isShowPrescriptionModal);
    setSelectedPrescription(null);
  };

  const togglePrescriptionImageModal = () => {
    setPrescriptionImageModal(!prescriptionImageModal);
  };

  const handleUpdatePrescription = (data) => {
    setIsShowPrescriptionModal(true);
    setSelectedPrescription(data);

    if (!isEmpty(data?.prescription)) {
      setPrescriptionObj(data?.prescription?.attachment);
    }
  };

  const handleSubmitPrescription = async () => {
    let updatedPrescription = null;

    if (!isEmpty(prescriptionObj)) {
      if (selectedPrescription?.patient) {
        updatedPrescription = await api({
          method: 'POST',
          url: `${API_BASE_URL}/document`,
          data: {
            title: `Prescription for consultaion with ${selectedPrescription?.doctor?.firstName} ${selectedPrescription?.doctor?.lastName}`,
            refType: 'patient',
            refId: selectedPrescription?.patient?.id,
            type: 'prescriptions',
            attachment: { ...prescriptionObj, forType: MODULE_TYPE.PATIENT_TRACKING },
          },
        });
      } else {
        toast.error('Please select patient.');
        return;
      }
    }

    if (updatedPrescription?.success === false) {
      toast.error('Something went wrong!');
      return;
    }

    await updateEnquiryRequest({
      url: `/consultation/admin/${consultation?.id}`,
      body: {
        prescriptionId: updatedPrescription?.id || null,
      },
    });
    togglePrescriptionModal();
  };

  // Update consultation status
  const [isShowStatusModal, setIsShowStatusModal] = useState(false);
  const [selectedType, setSelectedType] = useState(null);

  const [inputValues, setInputValues] = useState({
    paymentDetails: '',
    paymentStatus: false,
    paymentLink: '',
    meetingLink: '',
  });

  const toggleStatusModal = () => {
    setIsShowStatusModal(!isShowStatusModal);
    setSelectedType(null);
  };

  const handleUpdateStatus = async (typeObj) => {
    setSelectedType(typeObj);
    setIsShowStatusModal(true);
    setInputValues({
      paymentLink: consultation?.paymentLink,
      meetingLink: consultation?.meetingLink,
      paymentDetails: consultation?.paymentDetails,
      paymentStatus: consultation?.paymentStatus === 'completed',
    });
  };

  const handleSubmit = async () => {
    let payload = {
      [selectedType?.value]: inputValues[selectedType?.value]?.trim(),
      ...(selectedType?.value === 'paymentDetails'
        ? { paymentStatus: inputValues?.paymentStatus ? 'completed' : 'pending' }
        : {}),
    };

    await updateEnquiryRequest({
      url: `/consultation/admin/${consultation?.id}`,
      body: payload,
    });

    toggleStatusModal();
  };

  useEffect(() => {
    getConsultationDetails();
    myDoctorsList();
  }, []);

  const handleGeneratePaymentLink = async () => {
    if (isEmpty(consultation?.speciality)) {
      toast.error('Consultation invalid speciality');
      return;
    }

    const response = await createAdhocPaymentRequest({
      body: {
        userId: consultation?.createdBy?.id,
        amount: consultation?.feeAmount,
        currency: 'INR',
        paymentMethod: 'card',
        paymentDetails: {},
        description: `Doctor consulation with ${consultation?.speciality?.name}`,
        status: consultation?.paymentStatus,
        dueDate: moment()?.toISOString(),
        refId: `ask-an-expert_${consultation?.id}`,
        gateway: 'razorpay',
      },
    });

    if (response?.id) {
      const paymentResponse = await createAdhocPaymentLinkRequest({
        url: `/subscription/adhoc-payment/${response?.id}/create-payment-link`,
      });

      const paymentLink = paymentResponse?.paymentDetails?.short_url;

      if (!isEmpty(paymentLink)) {
        await updateEnquiryRequest({
          url: `/consultation/admin/${consultation?.id}`,
          body: {
            paymentLink,
          },
        });
      }
    }
  };

  const isConsultationFree = consultation?.feeAmount === 0;
  const miniCards = [
    {
      title: 'isCompleted',
      text: `${consultation?.status === consultationStatusEnum.COMPLETED ? 'Yes' : 'No'}`,
      textColor: `${consultation?.status === consultationStatusEnum.COMPLETED ? 'text-success' : 'text-danger'}`,
    },
    {
      title: 'Amount',
      text: `${
        isConsultationFree ? 'Free' : consultation?.feeAmount ? consultation?.feeAmount : ''
      } - (${titleCaseIfExists(consultation?.paymentStatus)})`,
      textColor:
        consultation?.paymentStatus === 'pending'
          ? 'text-warning'
          : consultation?.paymentStatus === 'completed'
          ? 'text-success'
          : 'text-dark',
    },
  ];

  const handleUpdateConsultationStatus = async () => {
    await updateConsultationStatus({
      method: 'PUT',
      url: `/consultation/admin/${consultation?.id}/update-status`,
      body: {
        status: consultationStatusEnum.ONGOING,
      },
    });
  };

  return (
    <>
      <div className="page-content">
        <Loader
          isActive={
            getConsultationDetailsLoading ||
            updateEnquiryLoading ||
            myDoctorsLoading ||
            createAdhocPaymentLinkLoading ||
            updateConsultationStatusLoading ||
            createAdhocPaymentLoading
          }
        />
        <Container fluid>
          <Breadcrumbs title="Consultation" breadcrumbItem="Consultation Details" />

          <Row>
            <Col md={3}>
              <Card className="overflow-hidden">
                <CardBody className="p-3">
                  <Row className="align-items-center">
                    {/* <Col sm="2">
                      <div className="avatar-md profile-user-wid m-auto">
                        <i className="bx bxs-user-circle" style={{ fontSize: '40px', color: '#3460BB' }} />
                      </div>
                    </Col> */}
                    <Col sm="12">
                      <h5 className="text-truncate">
                        {consultation?.patient?.firstName} {consultation?.patient?.lastName}
                      </h5>
                      <p className="text-muted mb-0 text-truncate-2">
                        {GET_GENDER[consultation?.patient?.gender]} - {printBirthDifference(consultation?.patient?.dob)}{' '}
                        old
                      </p>
                      <p className="mb-2">DOB: {printDate(consultation?.patient?.dob)} </p>
                      <a target="_blank" href={`/consultation/conversations?id=${consultation?.id}`}>
                        View Conversation{' '}
                        <span>
                          <i className="bx bx-link-external fs-6 mt-1 ms-1" />
                        </span>
                      </a>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            <Col md={2}>
              <Card className="mini-stats-wid">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted font-weight-medium mb-2">Consultation Request Date</p>
                      <h5 className={'mb-0 text-dark'}>{printDateTimeTwoLines(consultation?.createdDate)}</h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md={2}>
              <Card className="mini-stats-wid">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted font-weight-medium mb-3">Consultation Status</p>
                      <h5 className={'mb-0 text-dark'}>
                        {titleCaseIfExists(consultation?.status)}

                        <span style={{ cursor: 'pointer' }} className="ms-2" onClick={toggleUpdateStatusModal}>
                          <i className="fas fa-pencil-alt text-success " style={{ fontSize: '14px' }} />
                        </span>
                      </h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {map(miniCards, (card, key) => (
              <MiniCards
                mdCol={key === 1 ? 3 : 2}
                title={card?.title}
                text={card?.text}
                textColor={card?.textColor}
                iconClass={card?.iconClass}
                key={`_card_${key}`}
                removeIcon={true}
              />
            ))}
          </Row>
          <Row>
            <Col md={4}>
              <Card>
                <CardBody>
                  <CardTitle className="py-3 card-title text-center bg-light mb-0">Patient Information</CardTitle>
                  <p className="text-muted mb-4">{consultation?.bio}</p>
                  <div className="table-responsive" style={{ minHeight: 200 }}>
                    <Table className="mb-0">
                      <tbody>
                        <tr>
                          <th className="bg-white">Patient Id :</th>
                          <td className="bg-white">
                            <td className="bg-white">{consultation?.patient?.id}</td>
                          </td>
                        </tr>
                        <tr>
                          <th className="bg-white">Record Date :</th>
                          <td className="bg-white">
                            <td className="bg-white">{printDate(consultation?.patient?.growthDetails?.startDate)}</td>
                          </td>
                        </tr>
                        <tr>
                          <th className="bg-white">Height :</th>
                          <td className="bg-white">
                            {consultation?.patient?.growthDetails?.height}{' '}
                            {consultation?.patient?.growthDetails?.heightUnit}
                          </td>
                        </tr>
                        <tr>
                          <th className="bg-white">Weight :</th>
                          <td className="bg-white">
                            {consultation?.patient?.growthDetails?.weight}{' '}
                            {consultation?.patient?.growthDetails?.weightUnit}
                          </td>
                        </tr>
                        <tr>
                          <th className="bg-white">Head Circumference :</th>
                          <td className="bg-white">
                            {consultation?.patient?.growthDetails?.headCircumference}{' '}
                            {consultation?.patient?.growthDetails?.headCircumferenceUnit}
                          </td>
                        </tr>

                        {/* <tr>
                          <th className="bg-white">Patient Vaccination Region :</th>
                          <td className="bg-white">
                            <td className="bg-white">{consultation?.patient?.vaccinationRegion}</td>
                          </td>
                        </tr> */}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md={4}>
              <Card>
                <CardBody>
                  <h5 className="border-bottom pb-2 mb-3">Admin actions:</h5>
                  {isEmpty(consultation?.paymentLink) && (
                    <div className="mb-3">
                      <Button
                        className="w-100 text-start"
                        color={!isEmpty(consultation?.paymentLink) ? 'success' : 'light'}
                        disabled={consultation?.paymentStatus === 'completed'}
                        onClick={() => handleGeneratePaymentLink()}>
                        <i
                          className={`fas fa-check-circle ${
                            !isEmpty(consultation?.paymentLink) ? 'text-white' : 'text-dark'
                          } me-2 fs-6`}
                        />
                        Generate Payment Link
                      </Button>
                    </div>
                  )}

                  <div className="mb-3">
                    <Button
                      className="w-100 text-start"
                      color={!isEmpty(consultation?.paymentLink) ? 'success' : 'light'}
                      disabled={consultation?.paymentStatus === 'completed'}
                      onClick={() =>
                        handleUpdateStatus({
                          label: 'Payment Link',
                          value: 'paymentLink',
                        })
                      }>
                      <i
                        className={`fas fa-check-circle ${
                          !isEmpty(consultation?.paymentLink) ? 'text-white' : 'text-dark'
                        } me-2 fs-6`}
                      />
                      {!isEmpty(consultation?.paymentLink) ? 'Update' : 'Add'} Payment Link
                    </Button>
                  </div>

                  <div className="mb-3">
                    <Button
                      disabled={isEmpty(consultation?.paymentLink)}
                      color={
                        !isEmpty(consultation?.paymentLink) && consultation?.paymentStatus === 'completed'
                          ? 'success'
                          : 'light'
                      }
                      className="w-100 text-start"
                      onClick={() =>
                        handleUpdateStatus({
                          label: 'Payment Details',
                          value: 'paymentDetails',
                        })
                      }>
                      <i
                        className={`fas fa-check-circle ${
                          !isEmpty(consultation?.paymentLink) && consultation?.paymentStatus === 'completed'
                            ? 'text-white'
                            : 'text-dark'
                        } me-2 fs-6`}
                      />

                      {consultation?.paymentStatus === 'completed'
                        ? 'Payment completed'
                        : consultation?.paymentDetails
                        ? 'Payment Details Recieved'
                        : 'Add Payment Details'}
                    </Button>
                  </div>
                  <div className="mb-3">
                    <Button
                      disabled={consultation?.paymentStatus !== 'completed'}
                      className="w-100 text-start"
                      color={!isEmpty(consultation?.doctor) ? 'success' : 'light'}
                      onClick={() => handleShowDoctorAssignModal()}>
                      <i
                        className={`fas fa-check-circle ${
                          !isEmpty(consultation?.doctor) ? 'text-white' : 'text-dark'
                        } me-2 fs-6`}
                      />
                      {!isEmpty(consultation?.doctor) ? 'Update' : 'Add'} Assign Doctor
                    </Button>
                  </div>

                  <div className="mb-3">
                    <Button
                      className="w-100 text-start"
                      color={consultation?.status === consultationStatusEnum.ONGOING ? 'success' : 'light'}
                      disabled={
                        consultation?.status === consultationStatusEnum.ONGOING ||
                        consultation?.paymentStatus !== 'completed'
                      }
                      onClick={() => handleUpdateConsultationStatus()}>
                      <i
                        className={`fas fa-check-circle ${
                          consultation?.status === consultationStatusEnum.ONGOING ? 'text-white' : 'text-dark'
                        } me-2 fs-6`}
                      />
                      {consultation?.status !== consultationStatusEnum.ONGOING
                        ? 'Start Consultation'
                        : 'Consultation Started'}
                    </Button>
                  </div>

                  <div className="mb-3">
                    <Button
                      className="w-100 text-start"
                      color={!isEmpty(consultation?.meetingLink) ? 'success' : 'light'}
                      disabled={isEmpty(consultation?.doctor) || consultation?.paymentStatus !== 'completed'}
                      onClick={() =>
                        handleUpdateStatus({
                          label: 'Meeting Link',
                          value: 'meetingLink',
                        })
                      }>
                      <i
                        className={`fas fa-check-circle ${
                          !isEmpty(consultation?.meetingLink) ? 'text-white' : 'text-dark'
                        } me-2 fs-6`}
                      />
                      {!isEmpty(consultation?.meetingLink) ? 'Update' : 'Add'} Meeting Link
                    </Button>
                  </div>

                  <div className="mb-3">
                    <Button
                      className="w-100 text-start"
                      color={!isEmpty(consultation?.prescriptionId) ? 'success' : 'light'}
                      disabled={isEmpty(consultation?.doctor) || consultation?.paymentStatus !== 'completed'}
                      onClick={() => handleUpdatePrescription(consultation)}>
                      <i
                        className={`fas fa-check-circle ${
                          !isEmpty(consultation?.prescriptionId) ? 'text-white' : 'text-dark'
                        } me-2 fs-6`}
                      />
                      {!isEmpty(consultation?.prescriptionId) ? 'Update' : 'Add'} Prescription
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
            {(!isEmpty(consultation?.paymentLink) ||
              !isEmpty(consultation?.paymentDetails) ||
              !isEmpty(consultation?.meetingLink)) && (
              <Col md={4}>
                <Card>
                  <CardBody>
                    <CardTitle className="py-3 card-title text-center bg-light mb-4">Payment Details </CardTitle>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <table className="table">
                            <tbody>
                              {!isEmpty(consultation?.paymentLink) && (
                                <tr>
                                  <th className="bg-white" style={{ width: 150 }}>
                                    Payment Link :
                                  </th>
                                  <td className="bg-white">
                                    <a target="_blank" rel="noopener noreferrer" href={consultation?.paymentLink}>
                                      {consultation?.paymentLink}
                                    </a>
                                  </td>
                                </tr>
                              )}

                              <tr>
                                <th className="bg-white" style={{ width: 150 }}>
                                  Payment Status :
                                </th>
                                <td className="bg-white">
                                  <Badge
                                    className={
                                      consultation?.paymentStatus === 'pending'
                                        ? 'bg-warning'
                                        : consultation?.paymentStatus === 'completed'
                                        ? 'bg-success'
                                        : 'light'
                                    }>
                                    {titleCaseIfExists(consultation?.paymentStatus)}
                                  </Badge>
                                </td>
                              </tr>

                              {!isEmpty(consultation?.paymentDetails) && (
                                <tr>
                                  <th className="bg-white" style={{ width: 150 }}>
                                    Payment Details :
                                  </th>
                                  <td className="bg-white">{consultation?.paymentDetails}</td>
                                </tr>
                              )}

                              {!isEmpty(consultation?.meetingLink) && (
                                <tr>
                                  <th className="bg-white" style={{ width: 150 }}>
                                    Meeting Link :
                                  </th>
                                  <td className="bg-white">
                                    <a target="_blank" rel="noopener noreferrer" href={consultation?.meetingLink}>
                                      {consultation?.meetingLink}
                                    </a>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            )}
            <Col md={4}>
              <Card>
                <CardBody>
                  <CardTitle className="py-3 card-title text-center bg-light mb-4">Finding/Symptoms </CardTitle>
                  <Row>
                    <Col xl="12">
                      <div className="table-responsive">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th className="bg-white">Symptoms Description :</th>
                              <td className="bg-white">{consultation?.description}</td>
                            </tr>
                            <tr>
                              <th className="bg-white">Speciality Requested :</th>
                              <td className="bg-white">
                                {titleCaseIfExists(consultation?.speciality?.name)?.replaceAll('_', ' ')}
                              </td>
                            </tr>
                            <tr>
                              <th className="bg-white">Symptoms :</th>
                              <td className="bg-white">{consultation?.symptoms?.join(', ')}</td>
                            </tr>
                            <tr>
                              <th className="bg-white">Medical History :</th>
                              <td className="bg-white">
                                {consultation?.medicalHistory
                                  ?.filter((e) => e !== 'none')
                                  ?.map((e) => titleCaseIfExists(e))
                                  ?.join(', ')}
                              </td>
                            </tr>
                            <tr>
                              <th className="bg-white">Active :</th>
                              <td className="bg-white">
                                <Badge className={consultation?.active ? 'bg-success' : 'bg-danger'}>
                                  {consultation?.active ? 'Yes' : 'No'}
                                </Badge>
                              </td>
                            </tr>
                            <tr>
                              <th className="bg-white">Deleted :</th>
                              <td className="bg-white">
                                <Badge className={consultation?.deleted ? 'bg-success' : 'bg-danger'}>
                                  {consultation?.deleted ? 'Yes' : 'No'}
                                </Badge>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            {!isEmpty(consultation?.doctor) && (
              <Col md={4}>
                <Card>
                  <CardBody>
                    <CardTitle className="py-3 card-title text-center bg-light mb-4">Doctor Information </CardTitle>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th className="bg-white">Name :</th>
                                <td className="bg-white">
                                  {consultation?.doctor?.firstName} {consultation?.doctor?.lastName}
                                </td>
                              </tr>
                              <tr>
                                <th className="bg-white">Gender :</th>
                                <td className="bg-white">{GET_GENDER[consultation?.doctor?.gender]}</td>
                              </tr>

                              {!isEmpty(consultation?.doctor?.phoneNumber) && (
                                <tr>
                                  <th className="bg-white">Phone Number :</th>
                                  <td className="bg-white">{consultation?.doctor?.phoneNumber}</td>
                                </tr>
                              )}
                              {!isEmpty(consultation?.doctor?.experienceYear) && (
                                <tr>
                                  <th className="bg-white">Experience Year :</th>
                                  <td className="bg-white">{consultation?.doctor?.experienceYear}</td>
                                </tr>
                              )}
                              {!isEmpty(consultation?.doctor?.degree) && (
                                <tr>
                                  <th className="bg-white">Degree :</th>
                                  <td className="bg-white">{consultation?.doctor?.degree}</td>
                                </tr>
                              )}

                              {!isEmpty(consultation?.doctor?.areaOfExpertise) && (
                                <tr>
                                  <th className="bg-white">Area of expertise :</th>
                                  <td className="bg-white">{consultation?.doctor?.areaOfExpertise}</td>
                                </tr>
                              )}
                              <tr>
                                <th className="bg-white">Appointment Date :</th>
                                <td className="bg-white">{printDateTime(consultation?.appointmentDate)}</td>
                              </tr>

                              <tr>
                                <th className="bg-white">Expiry Date :</th>
                                <td className="bg-white">{printDateTime(consultation?.expiryDate)}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            )}
            {!isEmpty(consultation?.prescription) && (
              <Col md={4}>
                <Card>
                  <CardBody>
                    <CardTitle className="py-3 card-title text-center bg-light mb-4">Prescription Details </CardTitle>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th className="bg-white" style={{ width: 150 }}>
                                  Created Date :
                                </th>
                                <td className="bg-white">{printDateTime(consultation?.prescription?.createdDate)}</td>
                              </tr>
                              <tr>
                                <th className="bg-white" style={{ width: 150 }}>
                                  Updated Date :
                                </th>
                                <td className="bg-white">{printDateTime(consultation?.prescription?.updatedDate)}</td>
                              </tr>
                              <tr>
                                <th className="bg-white" style={{ width: 150 }}>
                                  Title :
                                </th>
                                <td className="bg-white">{consultation?.prescription?.title}</td>
                              </tr>
                              <tr>
                                <th className="bg-white" style={{ width: 150 }}>
                                  Type :
                                </th>
                                <td className="bg-white">{consultation?.prescription?.type}</td>
                              </tr>
                              <tr>
                                <th className="bg-white" style={{ width: 150 }}>
                                  Ref Type :
                                </th>
                                <td className="bg-white">{consultation?.prescription?.refType}</td>
                              </tr>
                              <tr>
                                <th className="bg-white" style={{ width: 150 }}>
                                  Attachement :
                                </th>
                                <td className="bg-white">
                                  <a
                                    href={stgURL + '/' + consultation?.prescription?.attachment?.original}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    {consultation?.prescription?.attachment?.name}
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <th className="bg-white" style={{ width: 150 }}>
                                  isPrivate :
                                </th>
                                <td className="bg-white">
                                  <Badge className={consultation?.prescription?.isPrivate ? 'bg-success' : 'bg-danger'}>
                                    {consultation?.prescription?.isPrivate ? 'Yes' : 'No'}
                                  </Badge>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            )}
            {!isEmpty(consultation?.images?.filter((doc) => doc?.type?.startsWith('image'))) && (
              <Col md={6}>
                <Card>
                  <CardBody>
                    <CardTitle className="py-3 card-title text-center bg-light mb-4">Images</CardTitle>
                    <Row>
                      {consultation?.images?.map((data) => (
                        <Col md="6" key={data?.id}>
                          <div className="border rounded-2">
                            <a
                              className="w-100 h-100"
                              href={showImage(data?.original)}
                              target="_blank"
                              rel="noopener noreferrer">
                              <img
                                style={{ height: 200 }}
                                src={showImage(data?.original)}
                                className="w-auto"
                                alt="Consultation"
                              />
                            </a>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            )}
            {!isEmpty(consultation?.images?.filter((doc) => doc?.type?.startsWith('application'))) && (
              <Col md={6}>
                <Card>
                  <CardBody>
                    <CardTitle className="py-3 card-title text-center bg-light mb-4">Uploaded Documents</CardTitle>
                    <Row>
                      {consultation?.images
                        ?.filter((doc) => doc?.type?.startsWith('application'))
                        ?.map((doc, index) => (
                          <Col md="6" key={data?.id}>
                            <a
                              href={showImage(doc?.original)}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-decoration-none">
                              📄 {doc?.name || `Document ${index + 1}`}
                            </a>
                          </Col>
                        ))}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            )}
            I am health consultant got the following query from the parent
            <br /> {GET_GENDER[consultation?.patient?.gender]} - {printBirthDifference(consultation?.patient?.dob)} old
            <br />
            {consultation?.description}.<br /> What should I advice
          </Row>
        </Container>

        {/* Assing Doctor */}

        <AssignDoctorModal
          isOpen={assignModalShow}
          toggle={toggleModal}
          selectedItem={consultation}
          myDoctors={myDoctors}
        />

        {/* Update Status  */}
        <Modal isOpen={isShowStatusModal} toggle={toggleStatusModal} centered={true} size="md">
          <ModalHeader toggle={toggleStatusModal}>Update {selectedType?.label}</ModalHeader>
          <ModalBody className="p-4">
            {selectedType?.value === 'paymentDetails' ? (
              <div>
                <div>
                  <Label for={'paymentDetails'} className="form-label  ">
                    Enter Payment Details
                  </Label>
                  <Input
                    id={'paymentDetails'}
                    name={'paymentDetails'}
                    type="textarea"
                    rows="7"
                    className="form-control"
                    placeholder={'Enter Payment Details'}
                    value={inputValues?.paymentDetails}
                    onChange={(e) => {
                      setInputValues({
                        ...inputValues,
                        paymentDetails: e.target.value,
                      });
                    }}
                  />
                </div>

                <FormGroup className="mt-4">
                  <Label className="form-label mb-3">is Payment Done</Label>
                  <div>
                    {[true, false].map((option, i) => (
                      <div key={`option_${i}`} className="form-check mb-3 d-inline-block me-4">
                        <input
                          id={`status_${option}`}
                          name={'paymentStatus'}
                          type="radio"
                          className="form-check-input"
                          value={option}
                          checked={inputValues?.paymentStatus === option}
                          onChange={() => {
                            setInputValues({
                              ...inputValues,
                              paymentStatus: option,
                            });
                          }}
                        />
                        <label className="form-check-label" htmlFor={`status_${option}`}>
                          {option ? 'Yes' : 'No'}
                        </label>
                      </div>
                    ))}
                  </div>
                </FormGroup>
              </div>
            ) : selectedType?.value === 'paymentLink' ? (
              <div>
                <Label for={'paymentLink'} className="form-label  ">
                  Enter Payment Link
                </Label>
                <Input
                  id={'paymentLink'}
                  name={'paymentLink'}
                  type="textarea"
                  rows="5"
                  className="form-control"
                  placeholder={'Enter Payment Link'}
                  value={inputValues?.paymentLink}
                  onChange={(e) => {
                    setInputValues({
                      ...inputValues,
                      paymentLink: e.target.value,
                    });
                  }}
                />
              </div>
            ) : (
              <FormGroup className="mb-4">
                <Label for={selectedType?.value} className="form-label  ">
                  Enter {selectedType?.label}
                </Label>
                <Input
                  id={selectedType?.value}
                  name={selectedType?.value}
                  type="textarea"
                  rows="7"
                  className="form-control"
                  placeholder={`Enter ${selectedType?.label}`}
                  value={inputValues[selectedType?.value]}
                  onChange={(e) => {
                    setInputValues({
                      ...inputValues,
                      [selectedType?.value]: e.target.value,
                    });
                  }}
                />
              </FormGroup>
            )}
          </ModalBody>
          <ModalFooter>
            <Button className="me-3" color="primary" onClick={handleSubmit}>
              Save
            </Button>
            <Button color="light" onClick={toggleStatusModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        {/* Upload Prescription  */}
        <Modal isOpen={isShowPrescriptionModal} toggle={togglePrescriptionModal} centered={true} size="md">
          <ModalHeader toggle={togglePrescriptionModal}>Update Prescription</ModalHeader>
          <ModalBody className="p-4">
            <FormGroup className="mb-4">
              <Label className="form-label mb-3">Upload Prescription</Label>
              <button type="button" className="btn btn-outline-dark w-100 py-3" onClick={togglePrescriptionImageModal}>
                Add Image
              </button>

              {!isEmpty(prescriptionObj) && (
                <div className="mt-4 text-center bg-light rounded-md p-4">
                  {!prescriptionObj?.originalRaw?.endsWith('.pdf') && (
                    <img
                      style={{
                        maxWidth: 150,
                      }}
                      className="mb-3 p-2"
                      src={stgURL + '/upload/' + prescriptionObj?.originalRaw}
                    />
                  )}
                  <div className="mb-2">
                    <a target="_blank" className="mb-3" href={stgURL + '/upload/' + prescriptionObj?.originalRaw}>
                      {prescriptionObj?.name}
                    </a>
                  </div>
                  <Button
                    color="danger"
                    className="w-100"
                    onClick={() => {
                      setSelectedPrescription(null);
                      setPrescriptionObj(null);
                    }}>
                    Remove
                  </Button>
                </div>
              )}

              <AttachmentImageUploadModal
                acceptTypes={'image/*,application/pdf'}
                onlyAttachmentUploadCall={true}
                isOpen={prescriptionImageModal}
                toggle={togglePrescriptionImageModal}
                forType={MODULE_TYPE.PATIENT_TRACKING}
                onUpload={(file) => {
                  togglePrescriptionImageModal();
                  setPrescriptionObj(file);
                }}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button className="me-3" color="primary" onClick={handleSubmitPrescription}>
              Save
            </Button>
            <Button color="light" onClick={togglePrescriptionModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        {/* Update status modal  */}
        <UpdateStatusModal
          isOpen={openUpdateStatusModal}
          toggle={toggleUpdateStatusModal}
          selectedItem={consultation}
        />
      </div>
    </>
  );
};

export default ConsultationDetails;
